import styled from 'styled-components';
import { rgba } from 'polished';

import { cA568FE, cFFFFFF } from '#/colors';

import * as walletFn from '#/features/wallet/functions';
import { useSystemConfig } from '#/features/system/system-config-context';
import { useBuildStarknetContractUrl } from '#/features/starknet';

import { Card, CardTitle } from './atoms';

export default function ContractAddress() {
  const config = useSystemConfig();
  const buildStarknetContractUrl = useBuildStarknetContractUrl();

  const token = config.getToken('USDC');

  return (
    <Card>
      <CardTitle css="margin-bottom: 10px;">Contract Details</CardTitle>
      <Content>
        <div>
          <Title>Paraclear contract</Title>
          <Link
            href={buildStarknetContractUrl(config.paraclear.address)}
            target="_blank"
            rel="nofollow noopener"
          >
            {walletFn.maskAccount(config.paraclear.address)}
          </Link>
        </div>

        <div>
          <Title>{token.symbol} contract</Title>
          <Link
            href={buildStarknetContractUrl(token.l2TokenAddress)}
            target="_blank"
            rel="nofollow noopener"
          >
            {walletFn.maskAccount(token.l2TokenAddress)}
          </Link>
        </div>
      </Content>
    </Card>
  );
}

const Content = styled.div`
  display: flex;
  gap: 24px;

  & > * {
    flex-shrink: 0;
  }
`;

const Title = styled.div`
  margin: 0;
  margin-bottom: 2px;
  font-size: 12px;
  font-size: 12px;
  color: ${rgba(cFFFFFF, 0.5)};
`;

const Link = styled.a`
  opacity: 0.7;
  font-size: 12px;
  margin: 0;

  &:hover {
    opacity: 1;
    color: ${cA568FE};
  }
`;
